var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard49(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#300B5C;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#300B5C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.6,59.1c-46.8,0-85.1,37.2-85.1,82.7s38.3,82.7,85.1,82.7s85.1-37.2,85.1-82.7c0-4.2-0.4-8.3-1-12.4 c-1-6.6-9-8.8-13.9-4.3c-2.4,2.2-3.4,5.4-2.9,8.6c0.4,2.5,0.7,5.2,0.7,8.1c0,36.4-30.6,66.1-68.1,66.1s-68.1-29.8-68.1-66.1 s30.6-66.1,68.1-66.1c11.3,0,22.1,2.9,31.7,7.6c3.5,1.7,7.6,1.3,10.4-1.4c3.8-3.7,3.3-9.9-1.3-12.4 C169.5,62.8,155.6,59.1,140.6,59.1z M225.5,75.4c-3.2-3.1-8.3-3.1-11.6,0L132,155l-22.3-21.7c-3.2-3.1-8.3-3.1-11.6,0 c-3.4,3.3-3.4,8.6,0,11.9l33.9,32.9l93.5-90.8C228.9,84.1,228.9,78.7,225.5,75.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard49);
export default __webpack_public_path__ + "static/media/card4_9.d25a7e54e0c0e67fbc59ddb80bfea3ff.svg";
export { ForwardRef as ReactComponent };